import { db } from './db.ts';

/**
 * Wipes everything this device holds. Called on sign-out.
 *
 * Hazard H7 in COMPLIANCE.md — one trainee seeing another's logbook — is the
 * most severe entry in the log, and a shared ward computer is exactly where it
 * would happen. Signing out must leave nothing behind.
 *
 * Deliberately clears rather than deletes the database: deleting can hang
 * indefinitely if another tab still holds a connection, and a sign-out that
 * hangs is a sign-out that does not happen.
 *
 * This is the one place in the client that empties entry tables. It is not a
 * soft delete and is not meant to be — the server holds the canonical copy, and
 * signing in again pulls it back.
 */
export async function clearLocalDatabase(): Promise<void> {
  /*
   * The table list is passed as an array rather than as arguments: Dexie's
   * variadic overloads stop at five tables, and this app now has seven.
   */
  await db.transaction(
    'rw',
    [
      db.cases,
      db.procedures,
      db.edtEntries,
      db.anaestheticCases,
      db.communications,
      db.outbox,
      db.meta,
    ],
    async () => {
      await Promise.all([
        db.cases.clear(),
        db.procedures.clear(),
        db.edtEntries.clear(),
        db.anaestheticCases.clear(),
        db.communications.clear(),
        db.outbox.clear(),
        db.meta.clear(),
      ]);
    },
  );
}
